/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArchitectsControllerFindAllQueryResponse, ArchitectsControllerFindAllQueryParams, ArchitectsControllerFindAll401, ArchitectsControllerFindAll403 } from "../../models/architectsController/ArchitectsControllerFindAll";

function getArchitectsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/architects` as const }  
  return res
}

/**
 * @summary Get all architects
 * {@link /api/v1/architects}
 */
export async function architectsControllerFindAll(params?: ArchitectsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArchitectsControllerFindAllQueryResponse, ResponseErrorConfig<ArchitectsControllerFindAll401 | ArchitectsControllerFindAll403>, unknown>({ method : "GET", url : getArchitectsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}